import { Fragment } from 'react';
import { formatCityRegionPostal } from '@/utils/formatAddress';
import { getCountryName } from '@/utils/locale/getCountryName';

interface AddressProps {
  address: {
    building?: string;
    street1?: string;
    street2?: string;
    city?: string;
    region?: string;
    postalCode?: string;
    countryCode?: string;
  };
}

const Address = ({ address }: AddressProps) => {
  if (!address) return null;

  const { building, street1, street2, city, region, postalCode, countryCode } = address;

  const cityRegionPostal = formatCityRegionPostal({ city, region, postalCode, countryCode });

  const addressLines = [
    building,
    street1,
    street2,
    cityRegionPostal,
    countryCode && getCountryName(countryCode),
  ]
    .filter(Boolean)
    .map((line, index) => {
      return (
        <Fragment key={index}>
          {line}
          <br />
        </Fragment>
      );
    });

  return <div>{addressLines}</div>;
};

export default Address;
